import React from 'react';
import { motion } from 'framer-motion';
import ScrollReveal from './ScrollReveal';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center relative px-4">
      <div className="container mx-auto relative z-10 flex flex-col items-center">
        <div className="text-center flex-1">
          <ScrollReveal>
            <motion.img
              src="/logo/mapu-logo-white.png"
              alt="Mapu Logo"
              className="w-32 sm:w-40 md:w-48 h-auto mb-6 sm:mb-8 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            />
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <motion.h1 
              className="font-heebo text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 drop-shadow-[0_1px_3px_rgba(0,0,0,0.3)] px-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              תן למקצועיות שלך <span className="text-pink-400 drop-shadow-[0_1px_2px_rgba(0,0,0,0.2)]">לבלוט</span>
            </motion.h1>
          </ScrollReveal>

          <ScrollReveal delay={0.4}>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
              {false && (
                <motion.a
                  href="#contact"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="btn-cta bg-cta hover:bg-cta-dark text-white rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto"
                >
                  בואו נתחיל
                </motion.a>
              )}
              {false && (
                <motion.a
                  href="#projects"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="btn-secondary bg-white/10 hover:bg-white/20 text-white rounded-xl font-semibold transition-all duration-300 backdrop-blur-sm w-full sm:w-auto"
                >
                  הפרויקטים שלנו
                </motion.a>
              )}
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={0.6}>
          <div className="relative z-10 mt-12 sm:mt-16">
            <motion.button
              onClick={() => scrollToSection('projects')}
              whileHover={{ scale: 1.1 }}
              className="text-white hover:text-white/90 transition-colors duration-300 block"
              animate={{ 
                y: [0, -10, 0]
              }}
              transition={{ 
                y: { 
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }
              }}
            >
              <svg className="w-10 h-10 sm:w-12 sm:h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </motion.button>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default HeroSection; 